@for (bar of bars; track bar) {
  <span class="spinner-bar" [style.--bar-index]="bar"></span>
}
